import request from '@/utils/request'

export default {
  getFundList(qry) {
    return request.post('/reference-data/getFunds', qry)
  },
  createFund(createFundReq) {
    return request.post('/reference-data/createFund', createFundReq)
  },
  updateFund(fund) {
    return request.post('/reference-data/updateFund', fund)
  },
}
